import axios from "axios";
import { ref } from "vue";

const userRef = ref((() => {
    try {
        return JSON.parse(localStorage.getItem("userdata") || "null");
    } catch {
        return null;
    }
})());

export function useUserData() {
    const setUser = (data) => {
        if (!data) {
            localStorage.removeItem("userdata");
            localStorage.removeItem("user");
            localStorage.removeItem("userid");
            userRef.value = null;
            return;
        }

        localStorage.setItem("userdata", JSON.stringify(data));
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("userid", data.id);
        userRef.value = data;
    };

    const syncFromStorage = () => {
        try {
            userRef.value = JSON.parse(localStorage.getItem("userdata") || "null");
        } catch {
            userRef.value = null;
        }
    };

    const usersList = async () => {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/users`
        );

        return response.data.data;
    };

    return {
        user: userRef,
        setUser,
        syncFromStorage,
        usersList,
    };
}
